module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1My41OSIgaGVpZ2h0PSI2NC4zNiIgdmlld0JveD0iMCAwIDUzLjU5IDY0LjM2Ij48cGF0aCBmaWxsPSIjZWIzYzAwIiBkPSJNLjUgNTEuNlYxMy4xTDM0LjU3LjUgNTMuMSA2LjQzdjUxLjg1bC0xOC41MyA1LjU4TC41IDUxLjZsMzQuMDcgNC4xVjEwLjg4bC0yMi4yMiA1LjJWNDYuNHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/office-365.svg
// module id = Qb1k
// module chunks = 89